"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckVentilated = function SvgIconTruckVentilated(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "truck ventilated icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Ventilated Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.199 6.054c2.195.066 5.685.674 7.94 4.057 3.757 5.635-3.777 13.618-3.777 13.618-2.101-1.408-4.071-.335-4.071-.335s-1.744-4.83-3.89-10.8c-1.122-3.12-.267-4.865.654-5.764 0 0 .7-.725 1.496-.776.797-.05 1.428-.006 1.648 0zm21.985 28.468c-.994 1.959-3.029 4.858-7.05 5.46-6.698 1.003-10.717-9.212-10.717-9.212 2.168-1.302 2.036-3.541 2.036-3.541s5.113.476 11.43 1.074c3.3.311 4.515 1.828 4.936 3.043 0 0 .359.943.066 1.685-.293.743-.602 1.295-.701 1.49zM5.366 39.487c-1.035-1.938-2.246-5.266-.435-8.908 3.017-6.063 13.69-3.504 13.69-3.504-.175 2.524 1.737 3.698 1.737 3.698s-3.32 3.917-7.43 8.752c-2.145 2.525-4.085 2.652-5.324 2.301 0 0-.976-.246-1.417-.911-.441-.666-.717-1.235-.82-1.428zm17.618-9.12a3.14 3.14 0 110-6.277 3.14 3.14 0 010 6.278z"
  }));
};

var _default = SvgIconTruckVentilated;
exports.default = _default;